import Axios from 'axios';
const projectsInfo = require('../../core-dms/projects/candao-dms-std/build.config.json');
import ignoreService from './ignoreService';
// import "babel-polyfill";
//Axios.defaults.headers.common['Cache-Control'] = 'cache';
var axios = Axios.create({
	headers: {
		'Content-Type' : 'multipart/form-data'
	},
	timeout:10000
});
Vue.prototype.$axios = axios;

import VueJsonp from 'vue-jsonp';
Vue.use(VueJsonp);


const request_way = { // 请求方式 - by Allen
	JSONP: 'jsonp', // Jsonp的请求方式
	PROXY: 'proxy', // 使用代理的请求方式
	NORMAL: 'post' // 常规的请求方式
}

;(function () {


	var __ACTION__ = 'post'
	, baseUrl = '/'
	, $service
	, $http//,$resource,resource
	, mode = 'production'
	, testData = null            // 测试数据
	, tempArr = ___PROJECT.split('-')
	, taskList = [] //请求的缓存数
	;

	//隐藏loading配置函数
	const hideLoadingFun = (actionName) =>{
		//忽略接口
		if(ignoreService.has(actionName)){
			return;
		}
		if(projectsInfo.useLoading && taskList.length === 1){
			Com.loadingHide();
		}
		taskList.length && taskList.pop();
	}

	/**
	 * 显示loading配置函数
	 * @param {String} actionName actionName
	 */
	const showLoadingFun = (actionName) =>{
		if(projectsInfo.useLoading){
			//忽略接口
			if(ignoreService.has(actionName)){
				return;
			}
			taskList.push(Date.now());
			Com.loadingShow();
		}
	}

	var isEmptyObject = function( obj ) {
    var name;
    for ( name in obj ) {
        return false;
    }
    return true;
	}

	var href = window.location.href.toLowerCase();
	if(href.indexOf('127.0.0.1') > -1 || href.indexOf('localhost')>-1 || href.indexOf('192.168')>-1){
		mode = 'development';
		__ACTION__ = request_way.PROXY;
		baseUrl = 'http://';
	}else if(href.indexOf('qc.can-dao.com')>-1
		|| href.indexOf('beta.can-dao.com')>-1
		|| href.indexOf('beta5.can-dao.com')>-1
		|| href.indexOf('http://10.200')>-1
	){
		mode = 'qc';
	}

	// irms-shop 请求链接特殊处理（请忽略）-- jerome
	if(tempArr[1] == 'irmshop'){
		var hrefList = href.split('/');
		if(hrefList[3]&&hrefList[3].indexOf('login')==-1&&hrefList[3].indexOf('#')==-1&&hrefList[3].indexOf('index')==-1&&hrefList[3].indexOf('middleware')==-1){
			baseUrl += hrefList[3] + '/';
		}
	}
	if(tempArr[2]&&(tempArr[2] == 'assessment' || tempArr[2] == 'monitor')){
		axios = Axios.create({
			headers: {
				'Content-Type' : 'application/json'
			}
		});
	}

	var errorCallback = {
		'500':()=>{Message&&Message.error('请求异常');console.error("500 错误 链接不存在");Com.loadingHide();;return true;}
		,'404':()=>{Message&&Message.error('请求异常');console.error("404 错误 请求的网页不存在");Com.loadingHide();;return true;}
		,'503':()=>{Message&&Message.error('请求异常');console.error("503 错误 服务不可用");Com.loadingHide();;return true;}
	};
	var service = {},$service,$resources,$caches,$baseData = {}
	,$alertFn=(msg)=>{alert(msg);}
	,$loadingFn=()=>{}
	,$loadedFn=()=>{}

	;
	service.config = {}

	var setCacheArray = [];

	const runResource = (actionName,actionData={},{type,dataType, isHideLoading},actionType="resources")=>{

		if(!actionName){console.error("!actionName");return ;}

		if(actionType == 'cache'){
			actionName = actionName==1?'set':(actionName==2?'get':'check');
			if(!$caches[actionName]){console.error('!$caches[actionName]:'+actionName);return false;}
		}else if(!$resources[actionName]){console.error('!$resources[actionName]:'+actionName);return false;}

		if (!isHideLoading) {
			$loadingFn();
		}
		let resource;
		if(actionType == 'cache'){
			resource = $caches[actionName];
		}else{
			resource = $resources[actionName];
		}


		// 判断是否为testData（拦截构造接口数据请求）
		if(resource&&resource.url&&resource.url.indexOf('interface-test')!=-1){
			let arr = resource.url.split('&');
			let _arr = arr[1].split('=');
			let result = {};
			if(testData){
				if(testData[_arr[1]]){
					result.status = 1;
					result.data = testData[_arr[1]];
				}else{
					result.status = 0;
					result.msg = 'testData中没有获取到' + _arr[1] +'属性数据！';
				}
			}else{
				result.status = 0;
				result.msg = 'testData无数据！';
			}
			// console.log('testData');
			let promise = new Promise(function(resolve) {
			  	// return result;
			  	let _result = JSON.parse(JSON.stringify(result));      // 深度拷贝对象
				let res = {..._result,$:$service};
				if (!isHideLoading) {
					$loadedFn();
				}
			  	resolve(res);
			});
			function resolve (res) {
				return res;
			}
			return promise;
		}

		if(resource && resource.data){
			if(resource.version && resource.version == 6){

			}else{
				actionData = {...resource.data||{},...actionData||{}};
			}
		}

		if(resource.version && resource.version == 6){
			var _actionData = {};
			_actionData.content = {...resource.data||{},...actionData||{}};
			_actionData.actionName = $resources[actionName].actionName;
			actionData = JSON.parse( JSON.stringify(_actionData) );
		}




		let url = resource.url;
		if(resource.version && resource.version == 6 || tempArr[2]&&tempArr[2] == 'assessment'){
			url+='?_name='+actionName;
		}else{
			url+='&_name='+actionName;
		}
		let proxyUrl = url;
		if (proxyUrl[0] !== '/') {
			proxyUrl = '/' + proxyUrl; // 判断原请求是否含有/ 没有则添加
		}
		url = baseUrl + url;
		var vueHttp;
		var options = {method: 'post',headers:{'Content-Type': 'application/json'}};//{params:{data:actionData,...$baseData||{}},method: 'post',headers:{'Content-Type': 'multipart/form-data'}};
		var data = {};
		//__ACTION__ = 'post'
		var lastAction = 'post';
		if(__ACTION__ === request_way.JSONP){
			//jsonp(url, [options])

			var urlArray = [];

			if(actionType == 'cache' && actionName!=='set'){
				data = {data:actionData,...($baseData||{})};
			}else {
				if(typeof actionData == 'object'){
					// actionData = {...actionData,...($baseData||{})}
					data = {data:JSON.stringify(actionData),...($baseData||{})};
				}else if(typeof actionData == 'string'){
					data = {data:actionData,...($baseData||{})};
				}
			}
			options.params = data;
			vueHttp = Vue.jsonp(url, options).then(response=>{
				if (!isHideLoading) {
					$loadedFn();
				}
				hideLoadingFun(actionName)
				return response;/* return response.json(); */
			});

		} else if (__ACTION__ === request_way.PROXY) {
			if(typeof actionData == 'string'){
				data = actionData;
			}else if(typeof actionData == 'object'){
				data = {...actionData};
			}
			vueHttp = axios[lastAction](`${proxyUrl}`,data).then(response=>{
				if (!isHideLoading) {
					$loadedFn();
				}
				hideLoadingFun(actionName)
				return response.data;
			}).catch(err=>{
				Message&&Message.error('程序异常,请联系管理员' + ',' + '错误日志:' + err.message);
				hideLoadingFun();console.error(err)
			});
		} else {
			//post(url, [body], [options])
			if(typeof actionData == 'string'){
				data = actionData;
			}else if(typeof actionData == 'object'){
				data = {...actionData};
			}
			vueHttp = axios[lastAction](url,data).then(response=>{
				if (!isHideLoading) {
					$loadedFn();
				}
				hideLoadingFun(actionName)
				return response.data;
			}).catch(err=>{
				Message&&Message.error('程序异常,请联系管理员' + ',' + '错误日志:' + err.message);
				hideLoadingFun();console.error(err)
			});
		}

		return vueHttp.then(
			result=>{if(resource.afterLoad && result && result.data){result.data=resource.afterLoad(result.data);}return {...result,$:$service};},
			(response,a)=>{
				if(!response){return false;}
				errorCallback[response.status] && errorCallback[response.status]()|| errorCallback[response.request.status] && errorCallback[response.request.status]() || console.log('response',response,a);
			}
		);


	}

	const runCache = (typeId,actionData={},{type,dataType})=>{

		let actionName = typeId==1?'set':(typeId==2?'get':'check');

		if(!$caches[actionName]){console.error('!$caches[actionName]:'+actionName);return false;}

		$loadingFn();

		let resource = $caches[actionName];

		let url = baseUrl+resource.url+'&_name='+actionName;

		var vueHttp;
		var options = {method: 'post',headers:{'Content-Type': 'multipart/form-data'}};//{params:{data:actionData,...$baseData||{}},method: 'post',headers:{'Content-Type': 'multipart/form-data'}};
		var data = {};
		if(__ACTION__ === 'jsonp'){
			//jsonp(url, [options])

			if(typeof actionData == 'object'){
				actionData = JSON.stringify(actionData);
			}
			data = {data:actionData}
			options.params = {...data,...($baseData||{})};
			vueHttp = Vue.http[__ACTION__](url,options);
		}else{
			//post(url, [body], [options])
			data = {...actionData,...($baseData||{})}
			vueHttp = Vue.http[__ACTION__](url,data/*,options*/);
		}
		return vueHttp.then(response=>{$loadedFn();return response.json();})
		.then(
			result=>{return {...result,$:$service};},
			response=>{
				if(!response){return {$:$service};}
				errorCallback[response.status] && errorCallback[response.status]() || console.log('response',response);
				return {$:$service};
			}
		);
	}

	var Vue;
	service.install = (_Vue,{resources={},caches=null,devUrl='',alertFn=null,error=null,baseData=null,isNeedTestData=false}={}) => {

		Vue = _Vue;

		//if(typeof Vue.http === 'undefined'){console.error("You must require `vue-resource` before.");return ;}

		$service = (action='',actionName,{type='',data=null,params=null,dataType='json', isHideLoading=false}={})=>{

			if(action == 'get'){
				return $service.get(actionName,params?params:data,{type,dataType,isHideLoading});
			}
			if(action == 'post'){
				return $service.post(actionName,data?data:params,{type,dataType,isHideLoading});
			}
			if(action == 'cache'){
				return $service.cache(actionName,data?data:params,{type,dataType,isHideLoading});
			}
		};

		$service.set = ({resources={},caches=null,devUrl='',alertFn=null,loadingFn=null,loadedFn=null,baseData=null,isNeedTestData=false,error=null,jsonp=true}={})=>{
			!isEmptyObject(resources) && ($resources = resources);
			caches    && ($caches = caches);
			alertFn   && ($alertFn = alertFn);
			loadingFn   && ($loadingFn = loadingFn);
			loadedFn   && ($loadedFn = loadedFn);
			// baseData   && ($baseData = {...$baseData,...baseData});
			if(baseData){
				if(__ACTION__ !== 'jsonp'){

					for(var k in baseData){
						if(!axios.defaults.params){axios.defaults.params = {};}
						axios.defaults.params[k] = baseData[k];
					}

				}

				$baseData = {...$baseData,...baseData};

			}

			if(isNeedTestData){
				let _href = window.location.href.toLowerCase();
				if(_href.indexOf('127.0.0.1') > -1 || _href.indexOf('localhost')>-1 || _href.indexOf('192.168')>-1){
					testData = (require('./../lib/testData/data_' + tempArr[1] + '.js')).default;
					// console.log('testData',testData);
				}
			}

			/* if(!jsonp){
				__ACTION__ = 'post';
			}else{
				__ACTION__ = 'jsonp';
			} */

			error && (errorCallback = error);

			if(mode == 'development' && devUrl){
				baseUrl = devUrl;
			}




		};

		$service.set({resources,caches,devUrl,alertFn,error,baseData,isNeedTestData});

		$service.do = $service.get = (actionName,actionData={},{type,dataType, isHideLoading}={})=>{
			showLoadingFun(actionName)
			let promise = runResource(actionName,actionData,{type,dataType, isHideLoading});
			return promise;
		}

		$service.post = (actionName,actionData={},{type,dataType, isHideLoading}={})=>{
			let promise = runResource(actionName,actionData,{type,dataType, isHideLoading});
			return promise;
		}

		$service.cache = (typeId=3,actionData={},{type,dataType, isHideLoading }={})=>{

			if(typeId == 1 && typeof actionData !== 'object'){console.error(`typeof actionData !== 'object'`); return ;}
			if(typeId != 1 && typeof actionData !== 'string'){console.error(`typeof actionData !== 'string'`); return ;}
			let promise = runResource(typeId,actionData,{type,dataType, isHideLoading},'cache');
			return promise;
		}

		$service.checkResult = (result,isAlert=false,_alertFn=null)=>{
			_alertFn = _alertFn?_alertFn:$alertFn;

			if(!result || (typeof result.status === 'undefined')){/*isAlert&&_alertFn('[!result]服务器返回空信息');*/return false;}
			if(result.status!==1){
				//fail info/modal
				isAlert && _alertFn(`${result.msg?result.msg:'未知错误'}`,result.status,result.statusCode);
				return false;
			}
			return true;
		}

		Vue.prototype.$service = $service;
		window.$service = $service;

	}


	if (typeof exports == "object") {
		module.exports = service
	} else if (typeof define == "function" && define.amd) {
		define([], function(){ return service })
	} else if (window.Vue) {
		Vue.use(service)
	}



})();



// WEBPACK FOOTER //
// core-build-local/plugs/service.js